import { PartTypeSchema, PartTypeType } from "../types";

export const isBar = (partType: PartTypeType | undefined | null): boolean => {
  if (!partType) {
    return false;
  }

  switch (partType) {
    case PartTypeSchema.enum.ROUND_BAR:
      return true;
    case PartTypeSchema.enum.SQUARE_BAR:
      return true;
    default:
      return false;
  }
};

export const isTube = (partType: PartTypeType | undefined | null): boolean => {
  if (!partType) {
    return false;
  }

  switch (partType) {
    case PartTypeSchema.enum.ROUND_TUBE:
      return true;
    case PartTypeSchema.enum.SQUARE_TUBE:
      return true;
    case PartTypeSchema.enum.RECTANGULAR_TUBE:
      return true;
    default:
      return false;
  }
};

export const isRound = (partType: PartTypeType | undefined | null): boolean => {
  if (!partType) {
    return false;
  }

  return partType === PartTypeSchema.enum.ROUND_BAR || partType === PartTypeSchema.enum.ROUND_TUBE;
};

export const isProfile = (partType: PartTypeType | undefined | null): boolean => {
  if (!partType) {
    return false;
  }

  return isTube(partType) || partType === PartTypeSchema.enum.PROFILE;
};

export const isBarOrProfile = (partType: PartTypeType | undefined | null): boolean => {
  return isBar(partType) || isProfile(partType);
};
